/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Dimmer, DimmerDimmable } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import InitLoader from "./login-config/InitLoader";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const LINE_MAP_PLACEHOLDER = (
  <React.Fragment>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
    <Table.Cell></Table.Cell>
  </React.Fragment>
);

const MAX_TABLE_CELLS = 40;

const START_MULTIPLIER = 10;
const END_INCREMENT = 10;

const UtilsInstance = new Utils();

var isABNetwork = false;

class LiveListMatrix extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      firstLineMap: LINE_MAP_PLACEHOLDER,
      secondLineMap: LINE_MAP_PLACEHOLDER,
      thirdLineMap: LINE_MAP_PLACEHOLDER,
      fourthLineMap: LINE_MAP_PLACEHOLDER,

      firstALineMap: LINE_MAP_PLACEHOLDER,
      secondALineMap: LINE_MAP_PLACEHOLDER,
      thirdALineMap: LINE_MAP_PLACEHOLDER,
      fourthALineMap: LINE_MAP_PLACEHOLDER,

      firstBLineMap: LINE_MAP_PLACEHOLDER,
      secondBLineMap: LINE_MAP_PLACEHOLDER,
      thirdBLineMap: LINE_MAP_PLACEHOLDER,
      fourthBLineMap: LINE_MAP_PLACEHOLDER,
      // loading
      percent: 100
    };
    this.InitLoaderRef = React.createRef();
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setDevices(data));
  }

  retrievePercentData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "getCurrentPercent/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ percent: data.percent }, () => {
        if (this.state.percent < 100) {
          this.InitLoaderRef.current.changeLoaderText(
            <>
              <p>
                {Strings.INITIALIZING_SCOPE_DP}<br />
                {Strings.LOADING}: {this.state.percent}%
              </p>
            </>
          );
        }
      }));
  }

  setDevices = (devices) => {
    isABNetwork = false;

    // Verify if the network contains devices with A or B on their names
    for (let i = 0; i < devices.length; i++) {
      if (UtilsInstance.treatUppercase(devices[i].address) !== UtilsInstance.treatUppercase(Strings.MASTER)) {
        if (devices[i].address.includes("A") || devices[i].address.includes("B")) {
          isABNetwork = true;
          break;
        }
      }
    }

    if (isABNetwork) {
      let aDevicesList = [];
      let bDevicesList = [];

      let aRegExp = new RegExp("A");
      let bRegExp = new RegExp("B");

      for (let i = 0; i < devices.length; i++) {
        if (devices[i].address.includes("A")) {
          devices[i].order = parseInt(devices[i].address.replace(aRegExp, ""));
          aDevicesList.push(devices[i]);
        }
        else if (devices[i].address.includes("B")) {
          devices[i].order = parseInt(devices[i].address.replace(bRegExp, ""));
          bDevicesList.push(devices[i]);
        }
        else if (UtilsInstance.treatUppercase(devices[i].address) === UtilsInstance.treatUppercase(Strings.MASTER)) {
          devices[i].order = 0;
          aDevicesList.push(devices[i]);
        }
      }

      aDevicesList.sort(UtilsInstance.sortBy(
        "order",
        false,
        parseInt));

      bDevicesList.sort(UtilsInstance.sortBy(
        "order",
        false,
        parseInt));

      const matrixList = this.createLiveListABMatrixList(aDevicesList, bDevicesList);
      this.buildABLineMaps(matrixList);

    }
    else {
      let devicesList = [];

      for (let i = 0; i < devices.length; i++) {
        if (UtilsInstance.treatUppercase(devices[i].address) === UtilsInstance.treatUppercase(Strings.MASTER)) {
          devices[i].order = 0;
          devicesList.push(devices[i]);
        }
        else {
          devices[i].order = parseInt(devices[i].address);
          devicesList.push(devices[i]);
        }
      }

      devicesList.sort(UtilsInstance.sortBy(
        "order",
        false,
        parseInt));

      const matrixList = this.createLiveListMatrixList(devicesList);
      this.buildLineMaps(matrixList);

    }
  }

  createLiveListABMatrixList = (aDevices, bDevices) => {
    let totalNumOfADevices = aDevices.length;
    let totalNumOfBDevices = bDevices.length;

    let numOfAInsertedDevices = 0;
    let numOfBInsertedDevices = 0;

    let aDevicesMatrixList = [];
    let bDevicesMatrixList = [];

    for (let i = 0; i < MAX_TABLE_CELLS; i++) {
      let hasAPositionBeenFilled = false;
      let hasBPositionBeenFilled = false;

      // Only look for devices to insert if not all of them have been already inserted
      if (numOfAInsertedDevices < totalNumOfADevices) {
        for (let j = 0; j < aDevices.length; j++) {
          if (aDevices[j].order === i) {
            aDevicesMatrixList.push(aDevices[j]);
            hasAPositionBeenFilled = true;
            numOfAInsertedDevices++;
            break;
          }
        }
      }

      // Only look for devices to insert if not all of them have been already inserted
      if (numOfBInsertedDevices < totalNumOfBDevices) {
        for (let j = 0; j < bDevices.length; j++) {
          if (bDevices[j].order === i) {
            bDevicesMatrixList.push(bDevices[j]);
            hasBPositionBeenFilled = true;
            numOfBInsertedDevices++;
            break;
          }
        }
      }

      if (!hasAPositionBeenFilled) {
        aDevicesMatrixList.push({
          "aOk": true,
          "address": i,
          "amplitude": 0,
          "amplitudeMin": 0,
          "bOk": true,
          "overshooting": 0,
          "status": ""
        });
      }

      if (!hasBPositionBeenFilled) {
        bDevicesMatrixList.push({
          "aOk": true,
          "address": i,
          "amplitude": 0,
          "amplitudeMin": 0,
          "bOk": true,
          "overshooting": 0,
          "status": ""
        });
      }

    }

    return {
      "aDevicesMatrixList": aDevicesMatrixList,
      "bDevicesMatrixList": bDevicesMatrixList
    };
  }

  createLiveListMatrixList = (devices) => {
    let totalNumOfDevices = devices.length;
    let numOfInsertedDevices = 0;

    let devicesMatrixList = [];

    for (let i = 0; i < MAX_TABLE_CELLS; i++) {
      let hasPositionBeenFilled = false;

      // Only look for devices to insert if not all of them have been already inserted
      if (numOfInsertedDevices < totalNumOfDevices) {
        for (let j = 0; j < devices.length; j++) {
          if (devices[j].order === i) {
            devicesMatrixList.push(devices[j]);
            hasPositionBeenFilled = true;
            numOfInsertedDevices++;
            break;
          }
        }
      }

      if (!hasPositionBeenFilled) {
        devicesMatrixList.push({
          "aOk": true,
          "address": i,
          "amplitude": 0,
          "amplitudeMin": 0,
          "bOk": true,
          "overshooting": 0,
          "status": ""
        });
      }
    }

    return devicesMatrixList;
  }

  buildABLineMaps = (matrixList) => {
    let firstLineStart = START_MULTIPLIER * (1 - 1);
    let firstLineEnd = firstLineStart + END_INCREMENT;

    let secondLineStart = START_MULTIPLIER * (2 - 1);
    let secondLineEnd = secondLineStart + END_INCREMENT;

    let thirdLineStart = START_MULTIPLIER * (3 - 1);
    let thirdLineEnd = thirdLineStart + END_INCREMENT;

    let fourthLineStart = START_MULTIPLIER * (4 - 1);
    let fourthLineEnd = fourthLineStart + END_INCREMENT;

    let firstALine = matrixList.aDevicesMatrixList.slice(firstLineStart, firstLineEnd);
    let secondALine = matrixList.aDevicesMatrixList.slice(secondLineStart, secondLineEnd);
    let thirdALine = matrixList.aDevicesMatrixList.slice(thirdLineStart, thirdLineEnd);
    let fourthALine = matrixList.aDevicesMatrixList.slice(fourthLineStart, fourthLineEnd);

    let firstBLine = matrixList.bDevicesMatrixList.slice(firstLineStart, firstLineEnd);
    let secondBLine = matrixList.bDevicesMatrixList.slice(secondLineStart, secondLineEnd);
    let thirdBLine = matrixList.bDevicesMatrixList.slice(thirdLineStart, thirdLineEnd);
    let fourthBLine = matrixList.bDevicesMatrixList.slice(fourthLineStart, fourthLineEnd);

    this.setState({
      firstALineMap: firstALine.map(device => (this.createDeviceCell(device))),
      secondALineMap: secondALine.map(device => (this.createDeviceCell(device))),
      thirdALineMap: thirdALine.map(device => (this.createDeviceCell(device))),
      fourthALineMap: fourthALine.map(device => (this.createDeviceCell(device))),

      firstBLineMap: firstBLine.map(device => (this.createDeviceCell(device))),
      secondBLineMap: secondBLine.map(device => (this.createDeviceCell(device))),
      thirdBLineMap: thirdBLine.map(device => (this.createDeviceCell(device))),
      fourthBLineMap: fourthBLine.map(device => (this.createDeviceCell(device)))
    });
  }

  buildLineMaps = (devicesMatrixList) => {
    let firstLineStart = START_MULTIPLIER * (1 - 1);
    let firstLineEnd = firstLineStart + END_INCREMENT;

    let secondLineStart = START_MULTIPLIER * (2 - 1);
    let secondLineEnd = secondLineStart + END_INCREMENT;

    let thirdLineStart = START_MULTIPLIER * (3 - 1);
    let thirdLineEnd = thirdLineStart + END_INCREMENT;

    let fourthLineStart = START_MULTIPLIER * (4 - 1);
    let fourthLineEnd = fourthLineStart + END_INCREMENT;

    let firstLine = devicesMatrixList.slice(firstLineStart, firstLineEnd);
    let secondLine = devicesMatrixList.slice(secondLineStart, secondLineEnd);
    let thirdLine = devicesMatrixList.slice(thirdLineStart, thirdLineEnd);
    let fourthLine = devicesMatrixList.slice(fourthLineStart, fourthLineEnd);

    this.setState({
      firstLineMap: firstLine.map(device => (this.createDeviceCell(device))),
      secondLineMap: secondLine.map(device => (this.createDeviceCell(device))),
      thirdLineMap: thirdLine.map(device => (this.createDeviceCell(device))),
      fourthLineMap: fourthLine.map(device => (this.createDeviceCell(device)))
    });
  }

  getTableBasedOnWindowHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();

    let browserHeightStyle = {
      height: browserHeight * 0.4
    };

    let tableSize = "large";

    if (browserHeight > 800) {
      tableSize = "large";
    }
    else {
      tableSize = "small";
    }

    if (isABNetwork) {
      return (
        <React.Fragment>

          <Table
            id="a-table"
            celled
            fixed
            singleLine
            textAlign="center"
            size={tableSize}
            definition
            style={browserHeightStyle}>

            <Table.Header fullWidth>
              <Table.Row>
                <Table.HeaderCell colSpan='11'>{Strings.A_DEVICES}</Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell width="1" />
                <Table.HeaderCell>0</Table.HeaderCell>
                <Table.HeaderCell>1</Table.HeaderCell>
                <Table.HeaderCell>2</Table.HeaderCell>
                <Table.HeaderCell>3</Table.HeaderCell>
                <Table.HeaderCell>4</Table.HeaderCell>
                <Table.HeaderCell>5</Table.HeaderCell>
                <Table.HeaderCell>6</Table.HeaderCell>
                <Table.HeaderCell>7</Table.HeaderCell>
                <Table.HeaderCell>8</Table.HeaderCell>
                <Table.HeaderCell>9</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row><Table.Cell verticalAlign="middle">0</Table.Cell>{this.state.firstALineMap}</Table.Row>
              <Table.Row><Table.Cell verticalAlign="middle">10</Table.Cell>{this.state.secondALineMap}</Table.Row>
              <Table.Row><Table.Cell verticalAlign="middle">20</Table.Cell>{this.state.thirdALineMap}</Table.Row>
              <Table.Row><Table.Cell verticalAlign="middle">30</Table.Cell>{this.state.fourthALineMap}</Table.Row>
            </Table.Body>

          </Table>

          <Table
            id="a-table"
            celled
            fixed
            singleLine
            textAlign="center"
            size={tableSize}
            definition
            style={browserHeightStyle}>

            <Table.Header fullWidth>
              <Table.Row>
                <Table.HeaderCell colSpan='11'>{Strings.B_DEVICES}</Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell width="1" />
                <Table.HeaderCell>0</Table.HeaderCell>
                <Table.HeaderCell>1</Table.HeaderCell>
                <Table.HeaderCell>2</Table.HeaderCell>
                <Table.HeaderCell>3</Table.HeaderCell>
                <Table.HeaderCell>4</Table.HeaderCell>
                <Table.HeaderCell>5</Table.HeaderCell>
                <Table.HeaderCell>6</Table.HeaderCell>
                <Table.HeaderCell>7</Table.HeaderCell>
                <Table.HeaderCell>8</Table.HeaderCell>
                <Table.HeaderCell>9</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row><Table.Cell verticalAlign="middle">0</Table.Cell>{this.state.firstBLineMap}</Table.Row>
              <Table.Row><Table.Cell verticalAlign="middle">10</Table.Cell>{this.state.secondBLineMap}</Table.Row>
              <Table.Row><Table.Cell verticalAlign="middle">20</Table.Cell>{this.state.thirdBLineMap}</Table.Row>
              <Table.Row><Table.Cell verticalAlign="middle">30</Table.Cell>{this.state.fourthBLineMap}</Table.Row>
            </Table.Body>

          </Table>

        </React.Fragment>
      );
    }
    else {
      return (
        <Table
          id="a-table"
          celled
          fixed
          singleLine
          textAlign="center"
          size={tableSize}
          definition
          style={browserHeightStyle}>

          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell width="1" />
              <Table.HeaderCell>0</Table.HeaderCell>
              <Table.HeaderCell>1</Table.HeaderCell>
              <Table.HeaderCell>2</Table.HeaderCell>
              <Table.HeaderCell>3</Table.HeaderCell>
              <Table.HeaderCell>4</Table.HeaderCell>
              <Table.HeaderCell>5</Table.HeaderCell>
              <Table.HeaderCell>6</Table.HeaderCell>
              <Table.HeaderCell>7</Table.HeaderCell>
              <Table.HeaderCell>8</Table.HeaderCell>
              <Table.HeaderCell>9</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row><Table.Cell verticalAlign="middle">0</Table.Cell>{this.state.firstLineMap}</Table.Row>
            <Table.Row><Table.Cell verticalAlign="middle">10</Table.Cell>{this.state.secondLineMap}</Table.Row>
            <Table.Row><Table.Cell verticalAlign="middle">20</Table.Cell>{this.state.thirdLineMap}</Table.Row>
            <Table.Row><Table.Cell verticalAlign="middle">30</Table.Cell>{this.state.fourthLineMap}</Table.Row>
          </Table.Body>

        </Table>
      );
    }
  }

  createDeviceCell = (device) => {
    if (device.status === Constants.GOOD) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={goodCellStyle}>
          {device.address} - {Strings.GOOD_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.ATTENTION) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={attentionCellStyle}>
          {device.address} - {Strings.ATTENTION_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.BAD) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={badCellStyle}>
          {device.address} - {Strings.BAD_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.FAULT) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={faultCellStyle}>
          {device.address} - {Strings.FAULT_STRING}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          disabled
          key={device.address}
          style={hiddenTableCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    this.retrievePercentData();
    // store intervalId in the state so it can be accessed later
    this.setState({
      intervalID: setInterval(this.retrieveData, 1000),
      percentIntervalID: setInterval(this.retrievePercentData, 5000)
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
    clearInterval(this.state.percentIntervalID);
  }

  render() {
    return (
      <DimmerDimmable style={dimmerStyle} as="div" dimmed={(this.state.percent < 100)}>

        <div style={screenStyle}>
          {this.getTableBasedOnWindowHeight()}
        </div>

        <Dimmer inverted active={(this.state.percent < 100)}>
          <InitLoader ref={this.InitLoaderRef} />
        </Dimmer>
      </DimmerDimmable>
    );
  }
}

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel
});

const screenStyle = {
  margin: "2vh 1vw",
  textAlign: "center"
};

const goodCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const attentionCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const faultCellStyle = {
  color: "black",
  backgroundColor: "red",
  verticalAlign: "middle"
};

const hiddenTableCellStyle = {
  color: "white",
  verticalAlign: "middle"
};

const dimmerStyle = {
  zIndex: 1
};

export default connect(mapStateToProps)(withRouter(LiveListMatrix));
